import { store } from "@root/store";
import {
  addToCartService,
  captureInterestPostService,
  checkPaymentStatusGetService,
  createCheckoutGetService,
  createNewOrderPostService,
  createOrderPostService,
  getPaymentMethodsService,
  getSignedPayloadService,
} from "./services";

import {
  showPaymentLoaderAction,
  showSelectAddressBottomSheetAction,
  showSelectStateBottomSheetAction,
  showPaymentProcessingPopupAction,
  togglePaymentMethodsModalAction,
  setPaymentMethodsAction,
  showCheckoutOptionsBottomSheetAction,
  setSelectedPaymentMethodAction,
  showSelectDynamicBundlingBottomSheetAction,
  dynamicBundlingPopupAction,
  setNotSupportedBottomsheet,
  toggleMultiPaymentMethodModalAction,
  setSelectedMultiPaymentMethodAction
} from "@src/components/BottomSheets/store/actions";
import Router from "@src/lib/router";
import parseError from "@src/utils/parseError";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { checkCourseStatus } from "@src/utils/goBack";

import { getAppVersion } from "@src/utils/getAxiosConfig";
import { PAYMENT_GATWAY_ENUMS } from "./constants";
import { hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { getPaymentObj } from "./getPaymentObj";
import {
  buyNowSuccessModal,
  setPaymentOptions,
  whatsappPaymentLoadingAction,
  setStandAloneUrl,
  setRetryingPayment,
  setPrevOrderId
} from "../components/Tabs/Overview/store/actions";
import { useSelector } from "react-redux";

export const handleDeeplinkExecutedV2 = (jsonVal,priceBottom, {upiIntentToken}) => {
  console.log("PAYMENT_OBJECT", jsonVal);
  const windowObject = window as any;
  var obj1 = JSON.parse(jsonVal);
  var obj2 = { ...obj1, paramTwo: {...JSON.parse(obj1.paramTwo), ...(upiIntentToken && { intentToken : upiIntentToken })} };
  var obj3 = { ...obj2 ,
    paramEight: JSON.parse(obj2?.paramEight || "{}")
  };
  var strnFyObj = {
    ...obj2.paramTwo,
  };
  delete strnFyObj.userAgent;
  obj3 = {
    ...obj2,
    paramTwo: JSON.stringify(strnFyObj),
    paramEight: JSON.stringify({
      ...obj3.paramEight,
      decoratedText: priceBottom?.decoratedText ? priceBottom?.decoratedText : null,
      discountPer: priceBottom?.discountPer.length ? priceBottom?.discountPer : null,
      finalPrice: priceBottom?.finalPrice.length ? priceBottom?.finalPrice : null,
    }),
  };
  console.log(JSON.stringify(obj3), "newPayment without userAgent");
  //android
  windowObject?.mobile?.onDeeplinkExecutedV2(JSON.stringify(obj3));
  //ios
  windowObject?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
    JSON.stringify(obj3)
  );
};

const createOrder = async (payload) => {
  const storeState = store?.getState() as any;

  const purchaseViaWhatsappV2 = storeState?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2;
  const courseName = storeState?.overviewReducer?.overViewDetails?.course?.details?.name;
  const isDynamicBundlingEnabled =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData
      ?.isDynamicBundlingEnabled;
  // // CHECK WHETHER THIS IS NEW PAYMENT FLOW FROM ANDROID/IOS END
  const isNewPaymentFlowLocalStorage = typeof window !== "undefined" && window.localStorage.getItem("isNewPaymentFlow");
  const isNewPaymentFlow = isNewPaymentFlowLocalStorage || storeState?.persistedDataReducer?.isNewPaymentFlow;
  const isMoneyBack = storeState?.overviewReducer?.overViewDetails?.course?.metaData?.addOnData?.addOnOptionId;
  const moneyBackEnable = storeState?.overviewReducer?.moneyBackGuarantee?.isRemoveButtonEnable;

  if (purchaseViaWhatsappV2 === 1) {
    try {
      store.dispatch(whatsappPaymentLoadingAction(true));
      const response = await captureInterestPostService({
        ...payload,
        ...(isMoneyBack && moneyBackEnable ? { optedAddOn: isMoneyBack } : null),
        isNewPaymentFlow: JSON.parse(isNewPaymentFlow),
        returnUrl: window?.location?.origin + window?.location?.pathname,
        courseName: courseName,
      });
      store.dispatch(whatsappPaymentLoadingAction(false));
      if (response?.status === 200) {
        store.dispatch(buyNowSuccessModal(true));
      }
    } catch (err) {
      store.dispatch(whatsappPaymentLoadingAction(false));
      console.log(err);
    }
  } else {
    const isGbpsFlowLocalStorage = typeof window !== "undefined" && window.localStorage.getItem("isGbpsFlow");
    const isGbpsFlow = isGbpsFlowLocalStorage || storeState?.persistedDataReducer?.isGbpsFlow;
    const isOutsideIndia = typeof window !== "undefined" && window.localStorage.getItem("isOutsideIndia")

    // OUTSIDE INDIA CONDITION
    const gbpsFlowValue: any = !!parseInt(isOutsideIndia) && parseInt(isGbpsFlow) === 2 ? 1 : parseInt(isGbpsFlow);

    if (isDynamicBundlingEnabled) {
      return await createNewOrderPostService({
        ...payload,
        ...(isMoneyBack && moneyBackEnable ? { optedAddOn: isMoneyBack } : null),
        isNewPaymentFlow: JSON.parse(isNewPaymentFlow),
        returnUrl: window?.location?.origin + window?.location?.pathname,
        isGbpsFlow: parseInt(gbpsFlowValue || 0)
      });
    } else {
      return await createOrderPostService({
        ...payload,
        ...(isMoneyBack && moneyBackEnable ? { optedAddOn: isMoneyBack } : null),
        isNewPaymentFlow: JSON.parse(isNewPaymentFlow),
        returnUrl: window?.location?.origin + window?.location?.pathname,
        isGbpsFlow: parseInt(gbpsFlowValue || 0),
        ...(payload?.autopayConfigId && {autopayConfigId: payload?.autopayConfigId || null}),
        ...(payload?.currentCourseAmountForAutoPay && { currentCourseAmountForAutoPay: payload?.currentCourseAmountForAutoPay || null } )
      });
    }
  }
};

export const retryPayment = async (orderId, isQrPayment = false) => {
  try {
    const searchParams = new URLSearchParams(window?.location?.search);

    const isPmsEnabled =
      store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPmsEnabled;

    if (!orderId) {
      orderId = window.localStorage.getItem("orderId");
    }

    if (isPmsEnabled) {
      store.dispatch(showPaymentLoaderAction(true));

      const res = await checkPaymentStatusGetService(orderId);

      makePayment({...res?.data?.data?.retryPayload, isQrPayment});
    } else {
      initialisePaymentService();
    }
  } catch (error) {
    alert(error);
  }
};

async function makePayment(payload: any, webEngagePayload?: any, comboCourseIds?: any, comboId?: any, upiIntentToken?: any) {
  const storeState = store?.getState() as any;
  const purchaseViaWhatsappV2 =
    storeState?.overviewReducer?.overViewDetails?.course
      ?.purchaseViaWhatsappV2;
  const priceBottom =
    storeState?.overviewReducer?.graphCourseData?.priceBottom;
  let bundleId =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
      ?.bundleId;
  const isComboActive =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData
      ?.isComboActive;
    const isStandAlone = storeState?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyCourseFlag === 1 ? true : false;
  const organisationData = storeState?.persistedDataReducer?.orgDetails?.organization;
  const isQRCodeEnabled = organisationData?.isQRCodeEnabled
  const isPaymentProEnabled = organisationData?.isPaymentProEnabled
  const selectedMultiPaymentMethod = storeState?.bottomSheetReducer?.selectedMultiPaymentMethod
  const isQrPayment = (isPaymentProEnabled && isQRCodeEnabled && selectedMultiPaymentMethod === PAYMENT_GATWAY_ENUMS.RAZORPAY_QR) ? true : false
  
  try {
    payload["bundleId"] = bundleId ? bundleId : null;
    payload["isQrPayment"] = isQrPayment
    if (isComboActive === 1) {
      payload["comboId"] = comboId;
      payload["comboCourseIds"] = comboCourseIds;
    }

    let createOrderPostServiceResponse = await createOrder(payload);

    const orderId = createOrderPostServiceResponse?.data?.data?.orderId;

    const deeplinkObj = createOrderPostServiceResponse?.data?.data?.deepLink;
    const doubtBuddyurl = createOrderPostServiceResponse?.data?.data?.doubtBuddyurl || null;

    if (webEngagePayload) {
      webEngagePayload.order_id = orderId;
      newWebEngage("course_buy_now_click", webEngagePayload);
    }
    window.localStorage.setItem("orderId", orderId);

    store.dispatch(showPaymentLoaderAction(false));
    store.dispatch(showCheckoutOptionsBottomSheetAction(false));
    store.dispatch(setSelectedPaymentMethodAction(null));
    store.dispatch(setSelectedMultiPaymentMethodAction(null));
    store.dispatch(toggleMultiPaymentMethodModalAction(false))
    setSelectedMultiPaymentMethodAction(null)
    if(createOrderPostServiceResponse?.data?.data?.doubtBuddyurl) {
      store.dispatch(setStandAloneUrl(createOrderPostServiceResponse?.data?.data?.doubtBuddyurl));
    }
    if (
      payload.gatewayCode === PAYMENT_GATWAY_ENUMS.RAZORPAY ||
      payload.gatewayCode === PAYMENT_GATWAY_ENUMS.GOOGLE
    ) {
      if(payload.isQrPayment){
        const {imageUrl, gatewayOrderId, gatewayKey} = createOrderPostServiceResponse?.data?.data || {}
        Router.push({
          pathname: '/checkout/qr',
          query: {
            imageUrl,
            gatewayOrderId,
            gatewayKey
          }
        });
      } else{
        handleDeeplinkExecutedV2(
          JSON.stringify(createOrderPostServiceResponse?.data?.data?.deepLink),
          {decoratedText: priceBottom?.decoratedText, discountPer: priceBottom?.discountPer, finalPrice: priceBottom?.finalPrice},
          { upiIntentToken: upiIntentToken || null}
        );
      }
    } else {
      window.location.href = `${deeplinkObj?.paramOne}`;
    }

  } catch (err) {
    console.log(err);
    if (purchaseViaWhatsappV2 !== 1) errorHandling(err);
  }
}

export const initialisePaymentService = async (comboCourseIds?: any, comboId?: any,   { upiIntentToken }: { upiIntentToken?: any } = {} // default empty object to avoid crash
) => {
  const storeState = store?.getState() as any;
  const windowObject = window as any;
  const priceBottom =
    storeState?.overviewReducer?.graphCourseData?.priceBottom;

  const paymentStatusEmblem =
    storeState?.overviewReducer?.overViewDetails?.course?.paymentStatusEmblem;

  const isPaymentProcessing = paymentStatusEmblem?.isPaymentProcessing;
  const purchaseViaWhatsappV2 =
    storeState?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2;
  const selectedCourse = storeState?.overviewReducer?.dynamicBundleList;
  const val = storeState?.overviewReducer?.dynamicCoursePrice?.priceBottom?.val;
  const dynamicBundlingPopup =
    storeState?.bottomSheetReducer?.dynamicBundlingPopup;
  const isDynamicBundling =
    storeState?.bottomSheetReducer?.showDynamicBundlingBottomSheet;

  let metaData = storeState?.overviewReducer?.overViewDetails?.course?.metaData;

  const dynamicBundleAddress =
    storeState?.overviewReducer?.dynamicCoursePrice?.priceBottom
      ?.isPhyicalShipmentCourse;
  let bundleId =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
      ?.bundleId;
  let isInstallmentEnabled = storeState?.overviewReducer?.overViewDetails?.course?.installments
      ?.isInstallmentEnabled
  let installmentId =
    storeState?.overviewReducer?.overViewDetails?.course?.installments
      ?.activeInstallmentId ||
    storeState?.overviewReducer?.overViewDetails?.course?.installments
      ?.installmentId;
  const stateSelected = storeState?.overviewReducer?.stateSelected;
  const isInternational =
    storeState?.overviewReducer?.overViewDetails?.course?.orgDetails
      ?.isInternational;
  const orgCode = storeState?.overviewReducer?.overViewDetails?.course?.orgDetails?.code
    
  let isPhysicalDeliveryEnabled = metaData?.isPhysicalDeliveryEnabled;
  const courseDetails = storeState?.overviewReducer?.overViewDetails?.course;
  let deviceInfo = windowObject?.androidData ? JSON.parse(windowObject?.androidData) : null
  let version = deviceInfo?.deviceInfo?.sdk
  let orgId = storeState?.overviewReducer?.overViewDetails?.course?.metaData?.orgId
    if (version && version < 24 && (orgId == 573212 || orgId == 170)) {
      return store.dispatch(setNotSupportedBottomsheet(true));
    }
  if (!isPhysicalDeliveryEnabled && !stateSelected && !isInternational) {
    // toast("Please select your state first");

    return store.dispatch(showSelectStateBottomSheetAction(true));
  }
  const selectedMultiPaymentMethod = storeState?.bottomSheetReducer?.selectedMultiPaymentMethod

  if (metaData?.isDynamicBundlingEnabled && !dynamicBundlingPopup && !selectedMultiPaymentMethod) {
    store.dispatch(showSelectDynamicBundlingBottomSheetAction(true));
    store.dispatch(showSelectAddressBottomSheetAction(false));
    store.dispatch(showSelectStateBottomSheetAction(false));
    return;
  } else {
    // if (metaData?.isDynamicBundlingEnabled && isDynamicBundling)
    store.dispatch(showSelectDynamicBundlingBottomSheetAction(false));
    if (isPaymentProcessing) {
      return store.dispatch(showPaymentProcessingPopupAction(true));
    }

    try {
      const deeplinkPayload = JSON.stringify({
        screen: COMMON_DEEPLINK_ACTIONS.BUY_NOW_CLICKED,
      });
      hitDeeplinkPerformAction(
        COMMON_DEEPLINK_ACTIONS.BUY_NOW_CLICKED,
        null,
        deeplinkPayload
      );
    } catch (e) {}

    const addressList = storeState?.physicalShipmentReducer?.addressList;
    // const courseIdRedux = storeState?.overviewReducer?.overViewDetails?.course?.metaData?.id;

    const activeAddress = storeState?.physicalShipmentReducer?.activeAddress;
    const deliveryFee = storeState?.physicalShipmentReducer?.deliveryFee;

    let priceDetails =
      storeState?.overviewReducer?.overViewDetails?.course?.priceDetails;

    let hasviewed = metaData?.hasViewed;
    let courseprice = priceDetails?.coursePrice;
    const organisationData =
      storeState?.persistedDataReducer?.orgDetails?.organization;
    let hascoupon =
      storeState?.overviewReducer?.graphCourseCouponListData?.totalCount > 0;
    // store.dispatch(showSelectAddressBottomSheetAction(true));
    if (
      (isPhysicalDeliveryEnabled || dynamicBundleAddress) &&
      !activeAddress &&
      !isInternational
    ) {
      // toast("Please add your address first");
      // console.log(Router?.router?.query?.courseId);
      if (
        storeState?.bottomSheetReducer?.showDynamicBundlingBottomSheet
      ) {
        store.dispatch(showSelectDynamicBundlingBottomSheetAction(false));
      }
      return addressList?.length
        ? store.dispatch(showSelectAddressBottomSheetAction(true))
        : Router?.push(`/${Router?.router?.query?.courseId}/physicaladdress`);
    } else if (
      !isPhysicalDeliveryEnabled &&
      !stateSelected &&
      !isInternational
    ) {
      // toast("Please select your state first");

      return store.dispatch(showSelectStateBottomSheetAction(true));
    }

    if (purchaseViaWhatsappV2 !== 1 && (!organisationData?.isQRCodeEnabled || selectedMultiPaymentMethod)) {
      store.dispatch(showPaymentLoaderAction(true));
    }

    let isCouponApplied = 0;
    let courseId = metaData?.id;
    const priceValue =
      storeState?.overviewReducer?.graphCourseData?.priceBottom?.val;

    let appliedCoupon =
      storeState?.overviewReducer?.graphCourseData?.appliedCoupon;

    if (appliedCoupon?.redeemId) {
      isCouponApplied = 1;
    }

    let couponObject;

    if (sessionStorage.getItem("APPLIEDCOUPON")) {
      couponObject = JSON.parse(sessionStorage.getItem("APPLIEDCOUPON"));
    }
    if (isCouponApplied) {
      couponObject = {
        code: appliedCoupon?.code,
        isCouponApplied: 1,
        redemptionId: appliedCoupon?.redeemId,
      };

      sessionStorage.setItem("APPLIEDCOUPON", JSON.stringify(couponObject));
    }

    let paymentPayload = {
      isCouponApplied: couponObject ? couponObject?.isCouponApplied : 0,
      currentAmount: metaData?.isDynamicBundlingEnabled ? val : metaData?.isAutoPayEnabled && Object.keys(metaData?.autopayConfig).length ?  parseInt((metaData?.autopayConfig?.trialAmountInRs * 100) as any) : priceValue,
      couponCode: couponObject?.code ? couponObject?.code : null,
      redemptionId: couponObject?.redemptionId
        ? couponObject?.redemptionId
        : null,
      state: stateSelected,
      deliveryAddressId:
        isPhysicalDeliveryEnabled || dynamicBundleAddress
          ? activeAddress?.id
          : 0,
      ocvmId: storeState?.overviewReducer?.promotedValidity?.id
        ? storeState?.overviewReducer?.promotedValidity?.id
        : null,
      ...(metaData?.isDynamicBundlingEnabled
        ? {
            courseId,
            recommendedCourseIds: selectedCourse,
          }
        : { courseId: courseId }
      ),
      ...(metaData?.isAutoPayEnabled && {isAutoPayOrder: 1}),
      ...(metaData?.isAutoPayEnabled && Object.keys(metaData?.autopayConfig).length ? { autopayConfigId: metaData?.autopayConfig?.id || null, currentCourseAmountForAutoPay: priceValue || null } : {}),
    };
    if (isPhysicalDeliveryEnabled === 2 || dynamicBundleAddress == 2) {
      paymentPayload["deliveryFee"] = deliveryFee;
    }

    const selectedPaymentMethod =
      storeState?.bottomSheetReducer?.selectedPaymentMethod;

    const webEngagePayload = {
      action: "Buy Now Click",
      has_viewed: hasviewed ? true : false,
      course_status: checkCourseStatus(),
      final_amount: priceValue / 100,
      course_price: courseprice,
      has_coupon: hascoupon ? true : false,
      course_name: `${storeState?.overviewReducer?.overViewDetails?.course?.details?.name}`,
      item: [
        {
          item_id: courseDetails?.metaData?.id,
          item_name: courseDetails?.details?.name,
          item_category: courseDetails?.categoryList,
          price: courseDetails?.priceDetails?.coursePrice
        }
      ],
    };

    if (
      !storeState?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPmsEnabled
    ) {
      if (isInternational) {
        let addToCartPayload = {
          courseList: [courseId],
          isCouponApplied: isCouponApplied,
          currentAmount: priceValue,
          couponCode: isCouponApplied ? appliedCoupon?.code : null,
          redemptionId: isCouponApplied ? appliedCoupon?.redeemId : null,
        };
        try {
          let addToCartResponse = await addToCartService(addToCartPayload);
          let orderId = addToCartResponse?.data?.data?.orderId;
          let signedPayload = {
            isCouponApplied: isCouponApplied,
            currentAmount: priceValue,
            couponCode: isCouponApplied ? appliedCoupon?.code : null,
            redemptionId: isCouponApplied ? appliedCoupon?.redeemId : null,
            orderId,
          };
          try {
            let signedPayloadResponse = await getSignedPayloadService(
              signedPayload
            );
            // console.log("signedPayloadResponse", signedPayloadResponse?.data?.data);
            let redirect_url =
              signedPayloadResponse?.data?.data?.payload?.redirect_url;
            if (redirect_url) {
              const deeplinkObj = JSON.stringify({
                screen: COMMON_DEEPLINK_ACTIONS.UTIL_WEBVIEW,
                paramOne: redirect_url,
              });
              store.dispatch(showPaymentLoaderAction(false));
              hitDeeplinkPerformAction(
                COMMON_DEEPLINK_ACTIONS.OPEN_WEBVIEW,
                deeplinkObj,
                null,
                true,
                false
              );
              hitDeeplinkPerformAction(null, null, deeplinkObj, false, true);
            }
          } catch (err) {
            errorHandling(err);
          }
        } catch (err) {
          errorHandling(err);
          // console.log("++++error", err);
        }
      } else {
        let createOrderPostServiceResponse = await createOrder({
          ...paymentPayload,
          apiVersion: 51,
        });

        const orderId = createOrderPostServiceResponse?.data?.data?.orderId;
        const gatewayOrderId =
          createOrderPostServiceResponse?.data?.data?.gatewayOrderId;
        // const gatewayTimeout =
        //   createOrderPostServiceResponse?.data?.data?.gatewayTimeout;
        // const notes = createOrderPostServiceResponse?.data?.data?.gatewayNotes;

        // const deeplinkObj = createOrderPostServiceResponse?.data?.data?.deepLink;

        // newWebEngage("Course Screen_ Buy Now Click", {
        //   action: "Buy Now Click",
        //   orderId: orderId + "",
        //   hasviewed: (hasviewed || 0) + "",
        //   coursestatus: checkCourseStatus(),
        //   finalamount: priceValue / 100 + "",
        //   courseprice: courseprice + "",
        //   hascoupon: (hascoupon || 0) + "",
        //   coursename: `${storeState?.overviewReducer?.overViewDetails?.course?.details?.name}`,
        // });
        newWebEngage("course_buy_now_click", webEngagePayload);
        window.localStorage.setItem("orderId", orderId);

        try {
          let checkoutServiceResponse = await createCheckoutGetService(orderId);
          // console.log(
          //   "checkoutServiceResponse",
          //   checkoutServiceResponse?.data?.data
          // );

          let gatewayTimeout =
            checkoutServiceResponse?.data?.data?.gatewayTimeout;

          if (checkoutServiceResponse?.data?.data?.notes) {
            store.dispatch(showSelectAddressBottomSheetAction(false));
            store.dispatch(showSelectStateBottomSheetAction(false));
            store.dispatch(showPaymentLoaderAction(false));
            handleDeeplinkExecutedV2(
              getPaymentObj(priceValue, gatewayOrderId, gatewayTimeout, {
                ...checkoutServiceResponse?.data?.data?.notes,
              }),
              {decoratedText: priceBottom?.decoratedText, discountPer: priceBottom?.discountPer, finalPrice: priceBottom?.finalPrice},
              { upiIntentToken: upiIntentToken || null}
            );
          }
        } catch (err) {
          errorHandling(err);
          // console.log("++++error", err);
        }

        // store.dispatch(showPaymentLoaderAction(false));
      }
    } else {
      if (selectedPaymentMethod) {
        await makePayment(
          {
            ...paymentPayload,
            gatewayCode: selectedPaymentMethod?.gatewayCode,
            checkoutPayload: isInternational ? 0 : 1,
            apiVersion: 51,
            paymentMethod: selectedPaymentMethod?.methodCode,
          },
          webEngagePayload
        );
      } else {
        try {
          const storeState = store?.getState() as any;
          // IS GOOGLE PAY ENABLED
          const isGooglePlayEnabled =
            storeState?.overviewReducer?.overViewDetails?.course
              ?.isGooglePlayEnabled;

          // CHECK WHETHER THIS IS NEW PAYMENT FLOW FROM ANDROID/IOS END
          const isNewPaymentFlowLocalStorage =
            typeof window !== "undefined" &&
            window.localStorage.getItem("isNewPaymentFlow");
          const isNewPaymentFlow =
            isNewPaymentFlowLocalStorage ||
            storeState?.persistedDataReducer?.isNewPaymentFlow;

          // CHECK WHETHER GBPS FLOW IS ENABLED
          const isGbpsFlowLocalStorage =
            typeof window !== "undefined" &&
            window.localStorage.getItem("isGbpsFlow");
          const isGbpsFlow =
            isGbpsFlowLocalStorage ||
            storeState?.persistedDataReducer?.isGbpsFlow;
          const isOutsideIndia = typeof window !== "undefined" &&
          window.localStorage.getItem("isOutsideIndia")
          // console.log(installmentId, isInstallmentEnabled, 'sakshat installments');
          const paymentMethodsCall = await getPaymentMethodsService({
            orgId: storeState?.overviewReducer?.overViewDetails?.course?.metaData?.orgId,
            currentAmount: priceValue,
            isNewPaymentFlow,
            isGbpsFlow,
            isOutsideIndia,
            isGooglePlayEnabled: isGooglePlayEnabled,
            ...(bundleId !== undefined ? { bundleId } : {}), // no need to send key if it is undefined
            ...(installmentId !== undefined && isInstallmentEnabled ? { installmentId } : { }), // isInstallmentEnabled and check no need to send key if it is undefined
          });
          const paymentMethodsResponse =
            paymentMethodsCall?.data?.data?.response;

          // LOGIC FOR GOOGLE PAYMENT COMES HERE
          if (
            paymentMethodsResponse?.showModal &&
            paymentMethodsResponse?.showGooglePay
          ) {
            store.dispatch(showCheckoutOptionsBottomSheetAction(true));
            store.dispatch(showPaymentLoaderAction(false));
            store.dispatch(setPaymentOptions(paymentMethodsResponse?.methods));
          } else if (paymentMethodsResponse?.showModal) {
            // FIRE MODAL
            store.dispatch(
              setPaymentMethodsAction(paymentMethodsResponse?.methods)
            );
            store.dispatch(togglePaymentMethodsModalAction(true));
            store.dispatch(showPaymentLoaderAction(false));
          } 
          else if(!purchaseViaWhatsappV2 && organisationData?.isQRCodeEnabled && organisationData?.isPaymentProEnabled && !selectedMultiPaymentMethod) {
            store.dispatch(showSelectAddressBottomSheetAction(false));
            store.dispatch(togglePaymentMethodsModalAction(false));
            store.dispatch(showPaymentLoaderAction(false));
            store.dispatch(
              toggleMultiPaymentMethodModalAction(true)
            );
          }else{
            try {
              const payload = {
                ...paymentPayload,
                gatewayCode: paymentMethodsResponse?.defaultGatewayCode,
                checkoutPayload: isInternational ? 0 : 1,
                apiVersion: 51,
                paymentMethod: null,
                isQrPayment : (organisationData?.isQRCodeEnabled && organisationData?.isPaymentProEnabled && selectedMultiPaymentMethod === PAYMENT_GATWAY_ENUMS.RAZORPAY_QR) ? true : false
              };
              await makePayment(
                payload,
                webEngagePayload,
                comboCourseIds,
                comboId,
                upiIntentToken
              );
            } catch (error) {
              errorHandling(error);
            }
          }
        } catch (err) {
          errorHandling(err);
          // console.log("++++error", err);
        }
      }
    }
  }
  store?.dispatch(dynamicBundlingPopupAction(false));
};
// };

const errorHandling = (err) => {
  store.dispatch(showPaymentLoaderAction(false));
  parseError(err);
};

export const handleRetryOption = (orderId) => {
    store.dispatch(setRetryingPayment(true))
    store.dispatch(setPrevOrderId(orderId))
    const isQRCodeEnabled = store?.getState()?.persistedDataReducer?.orgDetails?.organization?.isQRCodeEnabled;
    const isPaymentProEnabled = store?.getState()?.persistedDataReducer?.orgDetails?.organization?.isPaymentProEnabled;
    const purchaseViaWhatsappV2 = store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2;
    const selectedMultiPaymentMethod = store?.getState()?.bottomSheetReducer?.selectedMultiPaymentMethod;
    if (!purchaseViaWhatsappV2 && isQRCodeEnabled && isPaymentProEnabled && !selectedMultiPaymentMethod) {
      store.dispatch(toggleMultiPaymentMethodModalAction(true));
    } else {
      retryPayment(orderId);
    }
  }